module.exports = __webpack_public_path__ + "static/media/2026-calendar-promo-popup-960x540.523d0d23.jpg";